<div class="line-graph" [style.--line-graph-height]="height + 'px'">
  <section class="line-graph__chart-panel">
    <div class="line-graph__chart">
      <canvas
        *ngIf="hasData && visibleLineCount > 0"
        baseChart
        [type]="chartType"
        [data]="chartData"
        [options]="chartOptions"
      ></canvas>

      <div *ngIf="!hasData" class="line-graph__empty" i18n>No data available.</div>

      <div *ngIf="hasData && visibleLineCount === 0" class="line-graph__empty" i18n>
        All lines are hidden. Use the legend to show a line.
      </div>
    </div>
  </section>

  <aside class="line-graph__legend-panel" (mouseleave)="setHoveredLine(null)">
    <div class="line-graph__legend-header">
      <div>
        <div class="line-graph__legend-title"></div>
        <div class="line-graph__legend-summary" i18n>Showing {{ visibleLineCount }} of {{ totalLineCount }}</div>
      </div>
    </div>

    <div class="line-graph__legend-actions">
      <button type="button" i18n (click)="showAll()">Show all</button>
      <button type="button" i18n (click)="hideAll()">Hide all</button>
      <button type="button" i18n (click)="reload.emit()">Reload</button>
    </div>

    <div class="line-graph__search">
      <input
        type="text"
        i18n-placeholder
        placeholder="Search lines..."
        i18n-aria-label
        aria-label="Search lines"
        [value]="legendFilter"
        (input)="onLegendFilterInput($event)"
      />

      <button
        *ngIf="legendFilter"
        type="button"
        class="line-graph__search-clear"
        i18n-aria-label
        aria-label="Clear search"
        (click)="clearLegendFilter()"
      >
        ×
      </button>
    </div>

    <div *ngIf="filteredSeries.length > 0; else noLegendResults" class="line-graph__legend-list">
      <div
        *ngFor="let line of filteredSeries; trackBy: trackByLineId"
        class="line-graph__legend-item"
        [class.line-graph__legend-item--hidden]="isHidden(line.id)"
        [class.line-graph__legend-item--hovered]="hoveredLineId === line.id"
        (mouseenter)="setHoveredLine(line.id)"
      >
        <button
          type="button"
          class="line-graph__legend-toggle"
          [attr.aria-pressed]="!isHidden(line.id)"
          [attr.aria-label]="isHidden(line.id) ? 'Show ' + line.label : 'Hide ' + line.label"
          (click)="toggleLine(line.id)"
        >
          <span class="line-graph__legend-color" [style.background]="getLineColor(line.id)"></span>

          <span class="line-graph__legend-label">
            {{ line.label }}
          </span>
        </button>

        <div class="line-graph__legend-item-actions">
          <button
            type="button"
            class="line-graph__focus-button"
            i18n-title
            title="Show only this line"
            [attr.aria-label]="getFocusAriaLabel(line)"
            (click)="showOnly(line.id)"
            i18n
          >
            Focus
          </button>

          <button
            type="button"
            class="line-graph__visibility-button"
            [class.line-graph__visibility-button--hidden-line]="isHidden(line.id)"
            [attr.title]="getVisibilityTitle(line)"
            [attr.aria-label]="getToggleAriaLabel(line)"
            (click)="toggleLine(line.id)"
          >
            <nb-icon [icon]="isHidden(line.id) ? 'eye-off-outline' : 'eye-outline'"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <ng-template #noLegendResults>
      <div class="line-graph__no-results" i18n>No matching lines.</div>
    </ng-template>
  </aside>
</div>
